import { service } from "@/api/service ";
import { toastError } from "@/components/custom/Toast";
import router from "@/router";
const state = {
  policy: [],
  info: {},
  isExist: false,
};
const getters = {
  policyGet: (state) => state.policy,
  policyNumGet: (state) => parseInt(state.info.policy_number),
};
const actions = {
  checkPolicy({ commit }, payLoad) {
    commit("userInfo", payLoad);
    service.postFun(payLoad, `user/check_policy`).then(
      (obj) => {
        var result = obj?.data;
        commit("checkPolicy", result);
        result != null ? router.push("/v1/options") : false;
        // console.log(result), "this is the result";
        localStorage.setItem("oderId", result.id);
      },
      (error) => {
        console.log(error), "this is an error";
        toastError(error.response.data.errors[0]);
      }
    );
  },
};
const mutations = {
  checkPolicy(state, policy) {
    state.policy = policy;
  },
  userInfo(state, info) {
    state.info = info;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
